var map = {
	"./ch/about": [
		61072,
		1072
	],
	"./ch/about.json": [
		61072,
		1072
	],
	"./ch/assets": [
		85488,
		5488
	],
	"./ch/assets.json": [
		85488,
		5488
	],
	"./ch/chart": [
		16678,
		6678
	],
	"./ch/chart.json": [
		16678,
		6678
	],
	"./ch/common": [
		94621,
		4621
	],
	"./ch/common.json": [
		94621,
		4621
	],
	"./ch/network-notification": [
		194,
		194
	],
	"./ch/network-notification.json": [
		194,
		194
	],
	"./ch/orders": [
		21776,
		1776
	],
	"./ch/orders.json": [
		21776,
		1776
	],
	"./ch/place-order": [
		15532,
		5532
	],
	"./ch/place-order.json": [
		15532,
		5532
	],
	"./ch/wallet": [
		19881,
		9881
	],
	"./ch/wallet.json": [
		19881,
		9881
	],
	"./ct/about": [
		95609,
		5609
	],
	"./ct/about.json": [
		95609,
		5609
	],
	"./ct/assets": [
		45023,
		5023
	],
	"./ct/assets.json": [
		45023,
		5023
	],
	"./ct/chart": [
		69303,
		9303
	],
	"./ct/chart.json": [
		69303,
		9303
	],
	"./ct/common": [
		89709,
		9709
	],
	"./ct/common.json": [
		89709,
		9709
	],
	"./ct/network-notification": [
		86819,
		6819
	],
	"./ct/network-notification.json": [
		86819,
		6819
	],
	"./ct/orders": [
		95214,
		5214
	],
	"./ct/orders.json": [
		95214,
		5214
	],
	"./ct/place-order": [
		83321,
		3321
	],
	"./ct/place-order.json": [
		83321,
		3321
	],
	"./ct/wallet": [
		23497,
		3497
	],
	"./ct/wallet.json": [
		23497,
		3497
	],
	"./de/about": [
		54129,
		4129
	],
	"./de/about.json": [
		54129,
		4129
	],
	"./de/assets": [
		60791,
		791
	],
	"./de/assets.json": [
		60791,
		791
	],
	"./de/chart": [
		35179,
		5179
	],
	"./de/chart.json": [
		35179,
		5179
	],
	"./de/common": [
		21545,
		1545
	],
	"./de/common.json": [
		21545,
		1545
	],
	"./de/network-notification": [
		43607,
		3607
	],
	"./de/network-notification.json": [
		43607,
		3607
	],
	"./de/orders": [
		52424,
		2424
	],
	"./de/orders.json": [
		52424,
		2424
	],
	"./de/place-order": [
		76766,
		6766
	],
	"./de/place-order.json": [
		76766,
		6766
	],
	"./de/wallet": [
		88246,
		8246
	],
	"./de/wallet.json": [
		88246,
		8246
	],
	"./en/about": [
		49740,
		9740
	],
	"./en/about.json": [
		49740,
		9740
	],
	"./en/assets": [
		5284,
		5284
	],
	"./en/assets.json": [
		5284,
		5284
	],
	"./en/chart": [
		43408,
		3408
	],
	"./en/chart.json": [
		43408,
		3408
	],
	"./en/common": [
		40464,
		464
	],
	"./en/common.json": [
		40464,
		464
	],
	"./en/network-notification": [
		67073,
		7073
	],
	"./en/network-notification.json": [
		67073,
		7073
	],
	"./en/orders": [
		5726,
		5726
	],
	"./en/orders.json": [
		5726,
		5726
	],
	"./en/place-order": [
		84277,
		4277
	],
	"./en/place-order.json": [
		84277,
		4277
	],
	"./en/wallet": [
		82570,
		2570
	],
	"./en/wallet.json": [
		82570,
		2570
	],
	"./es/about": [
		45670,
		5670
	],
	"./es/about.json": [
		45670,
		5670
	],
	"./es/assets": [
		38379,
		8379
	],
	"./es/assets.json": [
		38379,
		8379
	],
	"./es/chart": [
		57968,
		7968
	],
	"./es/chart.json": [
		57968,
		7968
	],
	"./es/common": [
		10357,
		357
	],
	"./es/common.json": [
		10357,
		357
	],
	"./es/network-notification": [
		12452,
		2452
	],
	"./es/network-notification.json": [
		12452,
		2452
	],
	"./es/orders": [
		82770,
		4008
	],
	"./es/orders.json": [
		82770,
		4008
	],
	"./es/place-order": [
		75635,
		5635
	],
	"./es/place-order.json": [
		75635,
		5635
	],
	"./es/wallet": [
		86287,
		6287
	],
	"./es/wallet.json": [
		86287,
		6287
	],
	"./fr/about": [
		85754,
		5754
	],
	"./fr/about.json": [
		85754,
		5754
	],
	"./fr/assets": [
		25937,
		5937
	],
	"./fr/assets.json": [
		25937,
		5937
	],
	"./fr/chart": [
		40496,
		496
	],
	"./fr/chart.json": [
		40496,
		496
	],
	"./fr/common": [
		45167,
		5167
	],
	"./fr/common.json": [
		45167,
		5167
	],
	"./fr/network-notification": [
		18049,
		8049
	],
	"./fr/network-notification.json": [
		18049,
		8049
	],
	"./fr/orders": [
		70776,
		776
	],
	"./fr/orders.json": [
		70776,
		776
	],
	"./fr/place-order": [
		29931,
		9931
	],
	"./fr/place-order.json": [
		29931,
		9931
	],
	"./fr/wallet": [
		18755,
		8755
	],
	"./fr/wallet.json": [
		18755,
		8755
	],
	"./hu/about": [
		95274,
		5274
	],
	"./hu/about.json": [
		95274,
		5274
	],
	"./hu/assets": [
		68120,
		8120
	],
	"./hu/assets.json": [
		68120,
		8120
	],
	"./hu/chart": [
		72080,
		2080
	],
	"./hu/chart.json": [
		72080,
		2080
	],
	"./hu/common": [
		85474,
		5474
	],
	"./hu/common.json": [
		85474,
		5474
	],
	"./hu/network-notification": [
		53681,
		3681
	],
	"./hu/network-notification.json": [
		53681,
		3681
	],
	"./hu/orders": [
		17769,
		7769
	],
	"./hu/orders.json": [
		17769,
		7769
	],
	"./hu/place-order": [
		52770,
		2770
	],
	"./hu/place-order.json": [
		52770,
		2770
	],
	"./hu/wallet": [
		79028,
		9028
	],
	"./hu/wallet.json": [
		79028,
		9028
	],
	"./id/about": [
		49146,
		9146
	],
	"./id/about.json": [
		49146,
		9146
	],
	"./id/assets": [
		54080,
		4080
	],
	"./id/assets.json": [
		54080,
		4080
	],
	"./id/chart": [
		5586,
		5586
	],
	"./id/chart.json": [
		5586,
		5586
	],
	"./id/common": [
		81610,
		1610
	],
	"./id/common.json": [
		81610,
		1610
	],
	"./id/network-notification": [
		36865,
		6865
	],
	"./id/network-notification.json": [
		36865,
		6865
	],
	"./id/orders": [
		53214,
		3214
	],
	"./id/orders.json": [
		53214,
		3214
	],
	"./id/place-order": [
		9806,
		9806
	],
	"./id/place-order.json": [
		9806,
		9806
	],
	"./id/wallet": [
		83125,
		3125
	],
	"./id/wallet.json": [
		83125,
		3125
	],
	"./in/about": [
		25241,
		5241
	],
	"./in/about.json": [
		25241,
		5241
	],
	"./in/assets": [
		17087,
		7087
	],
	"./in/assets.json": [
		17087,
		7087
	],
	"./in/chart": [
		31333,
		1333
	],
	"./in/chart.json": [
		31333,
		1333
	],
	"./in/common": [
		431,
		431
	],
	"./in/common.json": [
		431,
		431
	],
	"./in/network-notification": [
		32117,
		2117
	],
	"./in/network-notification.json": [
		32117,
		2117
	],
	"./in/orders": [
		23458,
		3458
	],
	"./in/orders.json": [
		23458,
		3458
	],
	"./in/place-order": [
		88007,
		8007
	],
	"./in/place-order.json": [
		88007,
		8007
	],
	"./in/wallet": [
		58650,
		8650
	],
	"./in/wallet.json": [
		58650,
		8650
	],
	"./iq/about": [
		11721,
		1721
	],
	"./iq/about.json": [
		11721,
		1721
	],
	"./iq/assets": [
		55177,
		5177
	],
	"./iq/assets.json": [
		55177,
		5177
	],
	"./iq/chart": [
		3251,
		3251
	],
	"./iq/chart.json": [
		3251,
		3251
	],
	"./iq/common": [
		78850,
		8850
	],
	"./iq/common.json": [
		78850,
		8850
	],
	"./iq/network-notification": [
		16864,
		6864
	],
	"./iq/network-notification.json": [
		16864,
		6864
	],
	"./iq/orders": [
		77517,
		7517
	],
	"./iq/orders.json": [
		77517,
		7517
	],
	"./iq/place-order": [
		31204,
		1204
	],
	"./iq/place-order.json": [
		31204,
		1204
	],
	"./iq/wallet": [
		78334,
		8334
	],
	"./iq/wallet.json": [
		78334,
		8334
	],
	"./ir/about": [
		43177,
		3177
	],
	"./ir/about.json": [
		43177,
		3177
	],
	"./ir/assets": [
		30004,
		4
	],
	"./ir/assets.json": [
		30004,
		4
	],
	"./ir/chart": [
		940,
		940
	],
	"./ir/chart.json": [
		940,
		940
	],
	"./ir/common": [
		118,
		118
	],
	"./ir/common.json": [
		118,
		118
	],
	"./ir/network-notification": [
		6088,
		6088
	],
	"./ir/network-notification.json": [
		6088,
		6088
	],
	"./ir/orders": [
		79147,
		9147
	],
	"./ir/orders.json": [
		79147,
		9147
	],
	"./ir/place-order": [
		44990,
		4990
	],
	"./ir/place-order.json": [
		44990,
		4990
	],
	"./ir/wallet": [
		28141,
		8141
	],
	"./ir/wallet.json": [
		28141,
		8141
	],
	"./it/about": [
		216,
		216
	],
	"./it/about.json": [
		216,
		216
	],
	"./it/assets": [
		56507,
		6507
	],
	"./it/assets.json": [
		56507,
		6507
	],
	"./it/chart": [
		46944,
		6944
	],
	"./it/chart.json": [
		46944,
		6944
	],
	"./it/common": [
		9486,
		9486
	],
	"./it/common.json": [
		9486,
		9486
	],
	"./it/network-notification": [
		99684,
		9684
	],
	"./it/network-notification.json": [
		99684,
		9684
	],
	"./it/orders": [
		79622,
		9622
	],
	"./it/orders.json": [
		79622,
		9622
	],
	"./it/place-order": [
		29516,
		9516
	],
	"./it/place-order.json": [
		29516,
		9516
	],
	"./it/wallet": [
		47364,
		7364
	],
	"./it/wallet.json": [
		47364,
		7364
	],
	"./jp/about": [
		4949,
		4949
	],
	"./jp/about.json": [
		4949,
		4949
	],
	"./jp/assets": [
		18663,
		8663
	],
	"./jp/assets.json": [
		18663,
		8663
	],
	"./jp/chart": [
		16058,
		6058
	],
	"./jp/chart.json": [
		16058,
		6058
	],
	"./jp/common": [
		59650,
		9650
	],
	"./jp/common.json": [
		59650,
		9650
	],
	"./jp/network-notification": [
		11140,
		1140
	],
	"./jp/network-notification.json": [
		11140,
		1140
	],
	"./jp/orders": [
		62334,
		2334
	],
	"./jp/orders.json": [
		62334,
		2334
	],
	"./jp/place-order": [
		72841,
		2841
	],
	"./jp/place-order.json": [
		72841,
		2841
	],
	"./jp/wallet": [
		41355,
		1355
	],
	"./jp/wallet.json": [
		41355,
		1355
	],
	"./kr/about": [
		42184,
		2184
	],
	"./kr/about.json": [
		42184,
		2184
	],
	"./kr/assets": [
		70325,
		325
	],
	"./kr/assets.json": [
		70325,
		325
	],
	"./kr/chart": [
		33875,
		3875
	],
	"./kr/chart.json": [
		33875,
		3875
	],
	"./kr/common": [
		51353,
		1353
	],
	"./kr/common.json": [
		51353,
		1353
	],
	"./kr/network-notification": [
		36025,
		6025
	],
	"./kr/network-notification.json": [
		36025,
		6025
	],
	"./kr/orders": [
		94435,
		4435
	],
	"./kr/orders.json": [
		94435,
		4435
	],
	"./kr/place-order": [
		84281,
		4281
	],
	"./kr/place-order.json": [
		84281,
		4281
	],
	"./kr/wallet": [
		43315,
		3315
	],
	"./kr/wallet.json": [
		43315,
		3315
	],
	"./my/about": [
		58987,
		8987
	],
	"./my/about.json": [
		58987,
		8987
	],
	"./my/assets": [
		34061,
		4061
	],
	"./my/assets.json": [
		34061,
		4061
	],
	"./my/chart": [
		29582,
		9582
	],
	"./my/chart.json": [
		29582,
		9582
	],
	"./my/common": [
		39388,
		9388
	],
	"./my/common.json": [
		39388,
		9388
	],
	"./my/network-notification": [
		85678,
		5678
	],
	"./my/network-notification.json": [
		85678,
		5678
	],
	"./my/orders": [
		61895,
		1895
	],
	"./my/orders.json": [
		61895,
		1895
	],
	"./my/place-order": [
		85209,
		5209
	],
	"./my/place-order.json": [
		85209,
		5209
	],
	"./my/wallet": [
		18721,
		8721
	],
	"./my/wallet.json": [
		18721,
		8721
	],
	"./nl/about": [
		63113,
		3113
	],
	"./nl/about.json": [
		63113,
		3113
	],
	"./nl/assets": [
		39271,
		9271
	],
	"./nl/assets.json": [
		39271,
		9271
	],
	"./nl/chart": [
		10416,
		416
	],
	"./nl/chart.json": [
		10416,
		416
	],
	"./nl/common": [
		1211,
		1211
	],
	"./nl/common.json": [
		1211,
		1211
	],
	"./nl/network-notification": [
		16917,
		6917
	],
	"./nl/network-notification.json": [
		16917,
		6917
	],
	"./nl/orders": [
		17795,
		7795
	],
	"./nl/orders.json": [
		17795,
		7795
	],
	"./nl/place-order": [
		209,
		209
	],
	"./nl/place-order.json": [
		209,
		209
	],
	"./nl/wallet": [
		96750,
		6750
	],
	"./nl/wallet.json": [
		96750,
		6750
	],
	"./no/about": [
		23814,
		3814
	],
	"./no/about.json": [
		23814,
		3814
	],
	"./no/assets": [
		80736,
		736
	],
	"./no/assets.json": [
		80736,
		736
	],
	"./no/chart": [
		20974,
		974
	],
	"./no/chart.json": [
		20974,
		974
	],
	"./no/common": [
		70399,
		399
	],
	"./no/common.json": [
		70399,
		399
	],
	"./no/network-notification": [
		27233,
		7233
	],
	"./no/network-notification.json": [
		27233,
		7233
	],
	"./no/orders": [
		2177,
		8583
	],
	"./no/orders.json": [
		2177,
		8583
	],
	"./no/place-order": [
		79862,
		9862
	],
	"./no/place-order.json": [
		79862,
		9862
	],
	"./no/wallet": [
		59302,
		9302
	],
	"./no/wallet.json": [
		59302,
		9302
	],
	"./pl/about": [
		46198,
		6198
	],
	"./pl/about.json": [
		46198,
		6198
	],
	"./pl/assets": [
		79444,
		9444
	],
	"./pl/assets.json": [
		79444,
		9444
	],
	"./pl/chart": [
		22951,
		2951
	],
	"./pl/chart.json": [
		22951,
		2951
	],
	"./pl/common": [
		45878,
		5878
	],
	"./pl/common.json": [
		45878,
		5878
	],
	"./pl/network-notification": [
		24765,
		4765
	],
	"./pl/network-notification.json": [
		24765,
		4765
	],
	"./pl/orders": [
		91010,
		1010
	],
	"./pl/orders.json": [
		91010,
		1010
	],
	"./pl/place-order": [
		85507,
		5507
	],
	"./pl/place-order.json": [
		85507,
		5507
	],
	"./pl/wallet": [
		40083,
		83
	],
	"./pl/wallet.json": [
		40083,
		83
	],
	"./ru/about": [
		6217,
		6217
	],
	"./ru/about.json": [
		6217,
		6217
	],
	"./ru/assets": [
		10552,
		7156
	],
	"./ru/assets.json": [
		10552,
		7156
	],
	"./ru/chart": [
		88453,
		8453
	],
	"./ru/chart.json": [
		88453,
		8453
	],
	"./ru/common": [
		77247,
		7247
	],
	"./ru/common.json": [
		77247,
		7247
	],
	"./ru/network-notification": [
		50257,
		257
	],
	"./ru/network-notification.json": [
		50257,
		257
	],
	"./ru/orders": [
		63253,
		3253
	],
	"./ru/orders.json": [
		63253,
		3253
	],
	"./ru/place-order": [
		73031,
		3031
	],
	"./ru/place-order.json": [
		73031,
		3031
	],
	"./ru/wallet": [
		63211,
		3211
	],
	"./ru/wallet.json": [
		63211,
		3211
	],
	"./se/about": [
		95701,
		5701
	],
	"./se/about.json": [
		95701,
		5701
	],
	"./se/assets": [
		40189,
		189
	],
	"./se/assets.json": [
		40189,
		189
	],
	"./se/chart": [
		41438,
		1438
	],
	"./se/chart.json": [
		41438,
		1438
	],
	"./se/common": [
		74285,
		4285
	],
	"./se/common.json": [
		74285,
		4285
	],
	"./se/network-notification": [
		44425,
		4425
	],
	"./se/network-notification.json": [
		44425,
		4425
	],
	"./se/orders": [
		27544,
		7544
	],
	"./se/orders.json": [
		27544,
		7544
	],
	"./se/place-order": [
		21694,
		1694
	],
	"./se/place-order.json": [
		21694,
		1694
	],
	"./se/wallet": [
		23197,
		3197
	],
	"./se/wallet.json": [
		23197,
		3197
	],
	"./sk/about": [
		7582,
		7582
	],
	"./sk/about.json": [
		7582,
		7582
	],
	"./sk/assets": [
		1841,
		1841
	],
	"./sk/assets.json": [
		1841,
		1841
	],
	"./sk/chart": [
		44404,
		4404
	],
	"./sk/chart.json": [
		44404,
		4404
	],
	"./sk/common": [
		25446,
		5446
	],
	"./sk/common.json": [
		25446,
		5446
	],
	"./sk/network-notification": [
		31014,
		1014
	],
	"./sk/network-notification.json": [
		31014,
		1014
	],
	"./sk/orders": [
		35826,
		5826
	],
	"./sk/orders.json": [
		35826,
		5826
	],
	"./sk/place-order": [
		54818,
		4818
	],
	"./sk/place-order.json": [
		54818,
		4818
	],
	"./sk/wallet": [
		26288,
		6288
	],
	"./sk/wallet.json": [
		26288,
		6288
	],
	"./th/about": [
		47030,
		7030
	],
	"./th/about.json": [
		47030,
		7030
	],
	"./th/assets": [
		81750,
		1750
	],
	"./th/assets.json": [
		81750,
		1750
	],
	"./th/chart": [
		93713,
		3713
	],
	"./th/chart.json": [
		93713,
		3713
	],
	"./th/common": [
		63303,
		3303
	],
	"./th/common.json": [
		63303,
		3303
	],
	"./th/network-notification": [
		30766,
		766
	],
	"./th/network-notification.json": [
		30766,
		766
	],
	"./th/orders": [
		69417,
		9417
	],
	"./th/orders.json": [
		69417,
		9417
	],
	"./th/place-order": [
		76491,
		6491
	],
	"./th/place-order.json": [
		76491,
		6491
	],
	"./th/wallet": [
		95011,
		5011
	],
	"./th/wallet.json": [
		95011,
		5011
	],
	"./tr/about": [
		84602,
		4602
	],
	"./tr/about.json": [
		84602,
		4602
	],
	"./tr/assets": [
		39046,
		9046
	],
	"./tr/assets.json": [
		39046,
		9046
	],
	"./tr/chart": [
		8738,
		8738
	],
	"./tr/chart.json": [
		8738,
		8738
	],
	"./tr/common": [
		72973,
		2973
	],
	"./tr/common.json": [
		72973,
		2973
	],
	"./tr/network-notification": [
		88228,
		8228
	],
	"./tr/network-notification.json": [
		88228,
		8228
	],
	"./tr/orders": [
		29591,
		9591
	],
	"./tr/orders.json": [
		29591,
		9591
	],
	"./tr/place-order": [
		43980,
		3980
	],
	"./tr/place-order.json": [
		43980,
		3980
	],
	"./tr/wallet": [
		43596,
		3596
	],
	"./tr/wallet.json": [
		43596,
		3596
	],
	"./vn/about": [
		73637,
		3637
	],
	"./vn/about.json": [
		73637,
		3637
	],
	"./vn/assets": [
		18358,
		8358
	],
	"./vn/assets.json": [
		18358,
		8358
	],
	"./vn/chart": [
		5571,
		5571
	],
	"./vn/chart.json": [
		5571,
		5571
	],
	"./vn/common": [
		57922,
		7922
	],
	"./vn/common.json": [
		57922,
		7922
	],
	"./vn/network-notification": [
		55267,
		5267
	],
	"./vn/network-notification.json": [
		55267,
		5267
	],
	"./vn/orders": [
		57684,
		7684
	],
	"./vn/orders.json": [
		57684,
		7684
	],
	"./vn/place-order": [
		61849,
		1849
	],
	"./vn/place-order.json": [
		61849,
		1849
	],
	"./vn/wallet": [
		73237,
		3237
	],
	"./vn/wallet.json": [
		73237,
		3237
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;